module.exports = __webpack_public_path__ + "img/no-image.eb7da0b9.jpg";